import { DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI } from '../../../types/default-cloud-graph-calendar-event-entity-ati';
import { DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI } from '../../../types/default-cloud-graph-video-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { ZoomIcon, ZoomSearchResultIcon } from './icon';

// Entity types are the frontend projection of the connector's PRD + design docs: Zoom
// surfaces meeting recordings/transcripts (Video) and calendar meetings (Calendar), no
// document content. (Corroborated by the Alexander registration: VIDEO + CALENDAR_EVENT.)
export const zoomConfig: ThirdPartyConfig = {
	displayName: 'Zoom',
	id: 'zoom',
	resourceType: ProductResourceTypes3P.Zoom,
	icon: get3PLogo(ZoomIcon, 'Zoom', 'medium'),
	searchResultIcon: get3PLogo(ZoomSearchResultIcon, 'Zoom', 'large'),
	integrationAri: 'ari:cloud:platform::integration/zoom',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Video,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Calendar,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
